var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Success!")]),_c('icon',{attrs:{"name":"fa fa-check","size":"lg","gradient":"white","type":"success"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mt-4"},[_c('strong',[_vm._v("Your email has been sent! You should receive a confirmation email shortly.")])])
}]

export { render, staticRenderFns }